import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import './AdvisorMiniPanel_AddProtocolData.scss';
import { ICONS } from '@app/styles';
import { ConsiderationGroupEnum } from '@app/advisor-shared';
import { Renderer_ProtocolTitle } from '../../components/Renderer_ProtocolTitle/Renderer_ProtocolTitle.js';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { dispatch_OnAddProtocol } from '../../panels/AdvisorPanel_AddProtocolData/renderers/Renderer_AddProtocol/dispatchers.js';
import { Renderer_AddProtocol } from '../../panels/AdvisorPanel_AddProtocolData/renderers/Renderer_AddProtocol/Renderer_AddProtocol.js';
import { Renderer_AddOrder } from '../../panels/AdvisorPanel_AddProtocolData/renderers/Renderer_AddOrder/Renderer_AddOrder.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { PanelKey_AddProtocolData, PanelKey_Home, ProtocolInteractionType_AddOrder, ProtocolInteractionType_AddProtocol } from '@app/advisor-v5-shared';
import { ModuleFE_ProtocolInteraction } from '../../../_enum/protocol-interaction/index.js';
const relevantInteractionTypes = [ProtocolInteractionType_AddProtocol, ProtocolInteractionType_AddOrder];
export class AdvisorMiniPanel_AddProtocolData extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_AddProtocolData,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    __onAddProtocol(consideration) {
        this.setState({ interaction: consideration ? { consideration } : undefined });
        //Report analytics data
        if (consideration)
            ModuleFE_AdvisorAnalytics.trigger.addData.addData_ddx_open({ considerationLevel: consideration });
    }
    __onProtocolInteraction = () => {
        const interaction = ModuleFE_ProtocolInteraction.getInteraction();
        if (!interaction || !relevantInteractionTypes.includes(interaction.type))
            return this.setState({ interaction: undefined });
        this.setState({ interaction: interaction });
        //Report analytics data
        if (interaction.type === ProtocolInteractionType_AddOrder)
            ModuleFE_AdvisorAnalytics.trigger.addData.addData_order_open();
    };
    componentDidUpdate(prevProps, prevState) {
        //Opening the panel
        if (this.state.interaction && !prevState.interaction) {
            return ModuleFE_AdvisorMini.openPanel(PanelKey_AddProtocolData);
        }
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        if (!this.state.interaction)
            return 'Add Protocol Data';
        if ('consideration' in this.state.interaction)
            return 'Add Protocol';
        else
            return 'Add Order';
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                // close the add protocol interaction
                if ('consideration' in (this.state.interaction ?? {})) {
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.addData.addData_ddx_abandon();
                    dispatch_OnAddProtocol.dispatchUI();
                }
                else {
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.addData.addData_order_abandon();
                    ModuleFE_ProtocolInteraction.closeInteraction();
                }
                ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
            } });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = () => {
        if (!this.state.interaction)
            return _jsx(_Fragment, {});
        if ('consideration' in this.state.interaction) {
            const interaction = this.state.interaction;
            return `Add protocol to ${interaction.consideration === ConsiderationGroupEnum.HIGH_CONSIDERATION ? 'high' : 'low'} consideration`;
        }
        else {
            const interaction = this.state.interaction;
            return _jsx(Renderer_ProtocolTitle, { protocolId: interaction.protocolId });
        }
    };
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        if (!this.state.interaction)
            return _jsx(_Fragment, {});
        if ('consideration' in this.state.interaction) {
            const interaction = this.state.interaction;
            return _jsx(Renderer_AddProtocol, { consideration: interaction.consideration, scrollRef: scrollRef });
        }
        else {
            const interaction = this.state.interaction;
            return _jsx(Renderer_AddOrder, { protocolId: interaction.protocolId, scrollRef: scrollRef });
        }
    };
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_AddProtocolData.js.map